export type ProductListItemProps = {
  name: string
}

export const ProductListItemName = ({ name }: ProductListItemProps) => {
  return <h2 className="font-product m-0 text-center text-2xl">{name}</h2>
}
